import React from 'react'
import './404.scss'
export default (params) => {
    return '404'
}
